<script lang="ts">
import { defineComponent } from 'vue'
import GModel from './Model.vue'
import GFrame from './Frame.vue'
import GTemple from './Temple.vue'
import GLens from './Lens.vue'
import GLenOptions from './LenOptions.vue'
import GLogo from './Logo.vue'
import GBridge from './Bridge.vue'
import { actionTypes } from '@/hooks/enums'

export default defineComponent({
  name: 'RootCustomization',
  components: {
    [actionTypes.MODEL]: GModel,
    [actionTypes.FRAME]: GFrame,
    [actionTypes.TEMPLE]: GTemple,
    [actionTypes.LENS]: GLens,
    [actionTypes.LOGO]: GLogo,
    [actionTypes.LENOPTIONS]: GLenOptions,
    [actionTypes.BRIDGE]: GBridge,
  },
  props: {
    typeSchema: { type: String, default: () => '' },
  },
  emits: ['back'],
  setup(_, { emit }) {
    return {
      closeConfig() {
        emit('back')
      },
    }
  },
})
</script>

<template>
  <keep-alive>
    <component :is="typeSchema" :key="typeSchema" @back="closeConfig" />
  </keep-alive>
</template>
